export default __webpack_public_path__ + "static/youthWorkshops-c5eef37495d7120eeb64e4d9b2fe1e87.jpg";